<template>
    <div class="shipDetail">
        <ShipDetailBanner 
            :ship="ship"
        />

        <ShipExperience 
            :productModel="shipDetail.experienceItems || []"
            :cruiseRoyalExperienceItems="categories"
            :itemViewModels="shipDetail.itemViewModel||[]"
            :ships="ships"
        />

        <div class="shipDetail-learnMore">
            <div class="shipDetail-learnMore-title">
                <div class="shipDetail-learnMore-titleLine"></div>
                <div class="shipDetail-learnMore-titleTxt">猜您还需要了解</div>
            </div>

            <ShipDestinations 
                :destinations="shipDetail.destinations || []"
                :ship="ship"
            />

            <PromoCruise class="shipDetail-hotCruise"
            v-if="ship&&ship.shipCode"
                :cruiseType="1"
                :shipCode="ship.shipCode"
            />
        </div>

        

    </div>
</template>

<script>
const ShipDetailBanner = () => import('@/components/Ship/ShipDetailBanner')
const ShipExperience = () => import('@/components/Ship/ShipExperience')
const ShipDestinations = () => import('@/components/Ship/ShipDestinations')
const PromoCruise = () => import('@/components/Cruise/PromoCruise') 
export default {
    name: "ShipDetail",
    components: {
        ShipDetailBanner,
        ShipExperience,
        ShipDestinations,
        PromoCruise
    },
    asyncData ({ store, route }) {
        const params = route.params
        if (!params || !params.shipCode || params.shipCode.length == 0) {
            return
        } 
        return new Promise((resolve, reject) => {
            return store.dispatch('GET_SHIP_DETAIL', params.shipCode)
            .then(()=> {
                resolve();
            })
            .catch((e)=> {
                reject(e)
            })
        })
    },
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '')
        const params = this.$router.currentRoute.params
        if (!params || !params.shipCode || params.shipCode.length == 0) {
            location.href = "/Rccl.CustomPage/Ship"
            return
        }
    },
    methods: {
        
    },
    computed: {
        shipDetail () {
            return this.$store.state.page.shipDetail || {}
        },
        shipCode () {
            const params = this.$router.currentRoute.params || {}
            return params.shipCode || ""
        },
        ships () {
            return this.shipDetail.ships || []
        },
        ship () {
            return this.ships.find(r=>r.shipCode == this.shipCode) || {}
        },
        categories () {
            const categories = this.shipDetail.cruiseRoyalExperienceItemList || []
            // 超凡科技不显示
            return categories.filter(r=>r.category != '超凡科技')
        }
    }
}
</script>

<style lang="less" scoped>
.shipDetail {
    padding-bottom: 88px;

    .shipDetail-learnMore {
        background-color: #f2f2f2;
        .shipDetail-learnMore-title {
            padding: 14px 0;
            position: relative;
            background-color: #f2f2f2;
            .shipDetail-learnMore-titleLine {
                height: 1px;
                background-color: #808080;
                margin-left: 17.2%;
                margin-right: 17.2%;
            }
            .shipDetail-learnMore-titleTxt {
                width: 100px;
                position: absolute;
                top: 6px;
                left: 50%;
                margin-left: -50px;
                padding: 0 1.867%;
                background-color: #f2f2f2;
                text-align: center;
                color: #808080;
                font-size: 11px;
            }
        }
        .shipDetail-hotCruise {
            margin-top: 9px;
        }
    }
}
</style>